import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { ConfigService } from "@app/core/config.service";
import { AnalyticsService } from "@app/core/analytics.service";
import { UserService } from "@app/core/user.service";
import { User } from "@app/shared/user";

import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { InviteFriendsModalComponent } from "@app/shared/ribbon-banner/referrals/invite-friends-modal.component";

@Component({
  selector: "om-referral-banner",
  templateUrl: "./full-width-centered-banner.component.html",
  styleUrls: ["./full-width-centered-banner.component.scss"],
})
export class ReferralBannerComponent implements OnInit {
  user: User;
  private destroy$ = new Subject();

  constructor(
    private analyticsService: AnalyticsService,
    private config: ConfigService,
    private modalService: NgbModal,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  text: string;
  cta: string;
  icon: boolean = true;

  private bannerShownMixpanelProperties: object = {
    promotion_code_amount: null,
    promotion_code_percent: null,
  };

  ngOnInit() {
    this.userService.getUser();
    this.userService.user$.pipe(takeUntil(this.destroy$)).subscribe((user: User) => {
      this.user = user;

      this.text = "Give the gift of good health";
      if (this.user.referralDiscount) {
        this.text = `Give ${this.user.referralDiscount.getDiscountString()} off One Medical`;

        this.bannerShownMixpanelProperties = {
          promotion_code_amount: this.user.referralDiscount.getDiscountDollarAmount(),
          promotion_code_percent: this.user.referralDiscount.getDiscountPercentAmount(),
        };
      }
    });
    this.cta = "Invite Friends";
    this.autoShowReferralModal();
  }

  ngAfterViewInit() {
    this.analyticsService.trackReferralBannerShown(this.bannerShownMixpanelProperties);
  }

  ctaAction() {
    this.openReferralModal();
  }

  trackModalClosed(this) {
    this.analyticsService.trackReferralModalClosed();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openReferralModal() {
    let modal = this.modalService.open(InviteFriendsModalComponent);

    modal.result.then(
      () => {
        this.trackModalClosed();
      },
      () => {
        this.trackModalClosed();
      }
    ); // track closure on resolution AND rejection of the promise

    this.analyticsService.trackReferralModalOpen();
  }

  private autoShowReferralModal() {
    const eligibleForReferrals = !this.user.isDirectSignupEligible;
    const referralQuery = this.route.snapshot.queryParams.show_referral_modal === "true";

    if (eligibleForReferrals && referralQuery) {
      this.openReferralModal();
    }
  }
}
